import React from 'react';
import { useHistory } from 'react-router-dom';
import UnlockAccountTemplate from '@rexmas/rexmas-shared/lib/components/templates/login/UnlockAccount';
import rexIcon from '../../../img/rex-logo.svg';
import { pathLanguageCode } from '../../../conf/constants/constants';

function ResetUserAccount() {
  const history = useHistory();

  const handleSubmit = () => {
    history.push(`/remuneraciones/${pathLanguageCode}/login`);
  };

  return (
    <UnlockAccountTemplate
      onSubmit={handleSubmit}
      logo={rexIcon}
    />
  );
}

export default ResetUserAccount;
